<template>
  <div class="transaction-item-info">
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.transaction-info.date') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transactionDateTime }}
        </div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{
            $t('operation-information.transaction-info.partner-transaction-id')
          }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.parentOperation.operationTransactionId }}
        </div>
      </div>
    </div>
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.transaction-info.xpay-operation-id') }}
        </div>
        <div
          class="transaction-item-info__value xpay"
          @click="handleOperationIdClicked"
        >
          {{ transaction.parentOperation.operationId }}
        </div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.transaction-info.terminal-id') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.parentOperation.terminalId }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../../utils/gogocodeTransfer'
import { Transaction } from '@js-app/entities/transaction/Transaction'
import moment from 'moment/moment'
import { mapActions } from 'vuex'

export default {
  name: 'TransactionItemParentOperationInfo',
  props: {
    transaction: {
      type: Transaction,
    },
  },
  computed: {
    transactionDateTime() {
      return moment(this.transaction.parentOperation.operationDt).format(
        'YYYY.MM.DD, HH:mm:ss'
      )
    },
  },
  methods: {
    ...mapActions(['setShowFilters']),
    handleOperationIdClicked() {
      this.setShowFilters(true)
      $emit(
        this,
        'parentOperationIdClicked',
        this.transaction.parentOperation.operationId
      )
    },
  },
  emits: ['parentOperationIdClicked'],
}
</script>

<style lang="scss" scoped>
.xpay {
  cursor: pointer;
  text-decoration: underline;
  color: #64748B;
}
</style>
